import styled from 'styled-components';

export const Container = styled.div``;

export const Label = styled.div`
  text-align: left;
  font-family: 'AvenirNext';
  font-size: 10px;
  font-weight: 500;
  color: #96979a;
  margin-bottom: 5px;
  text-transform: uppercase;
`;

export default {
  Panel: {},
  Row: {
    margin: '0 -10px 10px'
  },
  Col: {
    padding: '0 10px'
  }
}
